export enum MonthPlannerEventEnum {
  CHANGE = "change",
}

export enum NavigationEventEnum {
  COMPLETE = "onlineBookingNavigateToComplete",
  DATE = "onlineBookingNavigateToDate",
  DETAILS = "onlineBookingNavigateToDetails",
  EXIT = "onlineBookingModalExit",
  HOME = "onlineBookingNavigateToHome",
  PAX = "onlineBookingNavigateToPax",
  PAYMENT = "onlineBookingNavigateToPayment",
  ROOMS = "onlineBookingNavigateToRooms",
  TIMES = "onlineBookingNavigateToTimes",
}

export enum TrackingEventEnum {
  PUSH_TO_DATALAYER = "onlineBookingPushToDatalayer",
}

export enum BookingEvent {
  OPEN_DRAWER = "openDrawer",
}
